<div class="four-oh-four">
    <div class="error-text">
        <h2 class="mat-display-2">Page not found</h2>
    </div>
</div>